export const closeTooltip = "nnsi3c";
export default {closeTooltip};